/**
 * ButtonTile - Pressure plate that opens button doors
 */

import { BaseTile, TextureDescriptor } from "./BaseTile";
import { TILE } from "../constants/gameConstants";
import { TileIndex } from "../types";

export class ButtonTile extends BaseTile {
  constructor({ col, row, id }: { col: number; row: number; id?: string }) {
    super(id ?? `button-${col}-${row}`, col, row);
  }

  tileType(): TileIndex {
    return TILE.BUTTON;
  }

  textureDescriptor(): TextureDescriptor {
    return { type: "png", path: "tiles/button-door-button.png" };
  }

  clone(): ButtonTile {
    const copy = new ButtonTile({ col: this.col, row: this.row, id: this.id });
    copy.sprite = this.sprite;
    return copy;
  }

  toJSON(): Record<string, any> {
    return { type: "button", id: this.id, col: this.col, row: this.row };
  }
}
